import _merge from 'lodash/merge';
import { Lightning } from '@lightningjs/sdk';
import { t } from '../../i18n';
import { contain, cover } from '../utils/textures';
import { SCREEN_HEIGHT, SCREEN_WIDTH } from '../utils/sizes';
import { Button } from '../button/button.component';
import Icon from '../icon/icon.component';
import { Scroll } from './scroll/scroll.component';
import { ProgramDescription } from './description/programDescription.component';
import {
  defaultContext,
  getContainerHeight,
  getInitialStyle,
  getScrollTop,
  getServiceIconViewBox,
  LOGO_DIMENSIONS,
  TEXT_WIDTH,
} from './programInformation.style';
import { PROGRAM_INFORMATION_CLOSED_SIGNAL } from './programInformation.constants';

export class ProgramInformation extends Lightning.Component {
  static _template() {
    return _merge(
      {
        rect: true,
        Overlay: {
          rect: true,
        },
        ContentContainer: {
          Top: {
            Title: {},
            Logo: {},
            ServiceIcon: {
              type: Icon,
            },
          },
          Scroll: {
            type: Scroll,
            content: {
              type: ProgramDescription,
              w: TEXT_WIDTH[defaultContext.screenSize],
            },
          },
        },
        ExitButton: {
          type: Button,
          visible: false,
          picto: {
            name: 'Cross',
          },
          label: t('global.close'),
        },
      },
      getInitialStyle(),
    );
  }

  _construct() {
    this._style = defaultContext;
  }

  set data(content) {
    if (!content) {
      return;
    }
    const { screenSize } = this._style;
    const { image, logo } = content;
    const logoSrc = (logo && logo.src) || '';
    const isLogoVisible = Boolean(logoSrc);
    const isServiceIconVisible = Boolean(content.servicePicto);

    this.patch({
      texture: cover(image.src, SCREEN_WIDTH[this._style.screenSize], SCREEN_HEIGHT[this._style.screenSize]),
      ContentContainer: {
        Top: {
          Title: {
            visible: !isLogoVisible,
            text: {
              text: content.title,
            },
          },
          Logo: {
            visible: isLogoVisible,
            texture: contain(logoSrc, LOGO_DIMENSIONS[screenSize].width, LOGO_DIMENSIONS[screenSize].height),
          },
          ServiceIcon: {
            visible: isServiceIconVisible,
            iconData: {
              picto: content.servicePicto,
              viewBox: getServiceIconViewBox(screenSize),
            },
          },
        },
      },
    });

    const scroll = this.tag('Scroll');
    const scrollableView = scroll.content;
    if (scrollableView) {
      scroll.y = getScrollTop({
        isLogoVisible,
        isServiceIconVisible,
        isTitleVisible: Boolean(content.title),
        screenSize,
      });
      scroll.h = getContainerHeight(screenSize) - scroll.y;
      scrollableView.data = content;
    }
  }

  _getFocused() {
    return this.tag('Scroll');
  }

  _handleKey() {
    return true;
  }

  _handleBack() {
    this.signal(PROGRAM_INFORMATION_CLOSED_SIGNAL);

    return true;
  }

  _handleEnter() {
    if (this.tag('ExitButton').visible) {
      this.signal(PROGRAM_INFORMATION_CLOSED_SIGNAL);
    }

    return true;
  }
}
